// extracted by mini-css-extract-plugin
export default {"root":"ActionButtonWithPrompt_root__+yQmi","placeHolderShimmer":"ActionButtonWithPrompt_placeHolderShimmer__bjaUg"};